import script from "./PaymentList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__